module.exports = __webpack_public_path__ + "img/line-dot-right.6c2bcd1d.svg";